import { memo } from 'react';

import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';
import { target } from '../../../registry/data/parts/target';
import { ariaLabel } from '../../../registry/data/parts/aria-label';

/**
 * Register the AnchorLink component.
 */
const register = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- This is a dynamic import.
  const component = memo(
    dynamic(
      async () => import(/* webpackChunkName: "AnchorLinkIndex" */ './index')
    )
  );
  const componentWithChildren = withChildren(component);

  Builder.registerComponent(componentWithChildren, {
    name: 'AnchorLink',
    friendlyName: 'Anchor Link',
    description:
      'A component that serves as an anchor link. Will render an anchor tag with the specified element ID, and wrap the children inside the anchor tag.',
    canHaveChildren: true,
    inputs: [target, ariaLabel],
    defaultChildren: [],
    image: uiImages.sectionImage
  });
};

export default register;
